import { useContext } from 'react';
import * as React from 'react';

import DownloadIcon from '@mui/icons-material/Download';
import { Button, Menu, useTheme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { NavigationContext, SubMenu } from '../../organisms';
import ActionButton from '../../organisms/Dashboard/songCard/ActionButton';

const useStyles = makeStyles()((theme) => ({
  button: {
    fontWeight: '500',
    [theme.breakpoints.down('lg')]: {
      fontSize: '12px',
    },
  },
}));

export interface DropdownButtonProps {
  children: React.ReactNode;
  variant: 'songbook' | 'sheet';
}

const DropdownButton: React.FC<DropdownButtonProps> = ({ children, variant }) => {
  const { classes } = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const { currentSubMenu, setCurrentSubMenu } = useContext(NavigationContext);
  const theme = useTheme();
  const { t } = useTranslation();

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: React.MouseEvent<HTMLDivElement>) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
    setCurrentSubMenu(null);
  };

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);

  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <>
      {variant === 'songbook' ? (
        <ActionButton
          id="btn_songbook_download"
          ref={anchorRef}
          iconType={DownloadIcon}
          label={t('home.songbook.download')}
          onClick={() => handleToggle()}
        />
      ) : (
        <Button
          style={{
            color: currentSubMenu === SubMenu.download ? theme.palette.primary.main : '#fff',
          }}
          onClick={() => {
            setCurrentSubMenu(SubMenu.download);
            handleToggle();
          }}
          id="btn_file_download"
          ref={anchorRef}
          className={classes.button}
          aria-controls={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
        >
          Download
        </Button>
      )}
      <Menu
        anchorEl={anchorRef.current}
        keepMounted
        open={open}
        onClose={handleClose}
        style={{ zIndex: 10000 }}
        onClick={handleClose}
        transformOrigin={{
          vertical: 'top',
          horizontal: variant === 'songbook' ? 'left' : 'center',
        }}
      >
        {children}
      </Menu>
    </>
  );
};

export default DropdownButton;
